import { useState, useEffect } from "react";
import AIheader from '../../RentAI/AIheader';
import Footer from '../../../Component/Footer/Footer';
//import BetaWaitlist from "../../../Component/Beta-Waitlist/BetaWaitlist";
//import JoinPriorityWaitlistBtn from "../../../Component/ViralLoops/JoinPriorityWaitlistBtn";
import './FleetOperators.css';
// import BlogFaq from "../../../Component/blog/BlogFaq/BlogFaq";
import Getstarted from "../../../Component/GetStarted/Getstarted";

const FleetOperators = ()=> {

    const [showGetstarted, setShowGetstared] = useState(false);

    const [activeIndex, setActiveIndex] = useState(0);
    
    const menuItems = [
        { id: "fleet_blog_1", text: "Navigating the Uncertainty" },
        { id: "fleet_blog_2", text: "The Risks of Relying on Marketplaces" },
        { id: "fleet_blog_3", text: "The Power of Direct Rentals" },
        { id: "fleet_blog_4", text: "How Rentid Helps Hosts Take Back Control" },
        { id: "fleet_blog_5", text: "Your Next Chapter Starts Now" },
    ];

    useEffect(() => {
        const handleScroll = () => {
            let scrollPosition = window.scrollY - 400; // Adjust offset for better accuracy
            let foundIndex = 0;

            menuItems.forEach((item, index) => {
                const section = document.getElementById(item.id);
                if (section) {
                    const offsetTop = section.offsetTop;
                    if (scrollPosition >= offsetTop) {
                        foundIndex = index;
                    }
                }
            });

            setActiveIndex(foundIndex);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [menuItems]);

    return (
        <>
<AIheader/>
<Getstarted
showJoinWaitList={showGetstarted}
onClose={() => setShowGetstared(false)}
onOpen={() => setShowGetstared(true)}
/>
 
{/* START maxBannerMain */}
<section className="maxBannerMain fleetBannerMain">
    <div className="maxBannerOuter">
        <div className="container">
                <div className='row align-items-center'>
                    <div className='col-lg-6 col-md-6 col-sm-12'>
                        <div className='maxBannerLeft'>
                            {/* <div className="blogHeadingInner">
                                <img width="17px" src="/img/blog/blog_icon_blue.svg" alt="icon"/>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="/blogs">Blog</a></li>
                                        <img width="" src="/img/arrow-right-nav.svg" alt="arrow"/>
                                        <li className="breadcrumb-item active" aria-current="page">Article 003</li>
                                    </ol>
                                </nav>
                            </div> */}
                            <small>Category name</small>
                            <h2>The Unfortunate Fall of <span className="pinkSpan">GetAround</span> and <span className="orangeSpan">HyreCar</span>: What’s Next for Fleet Operators?</h2>
                            {/* <p>Published: Mar 4, 2025</p>
                            <p><span>Estimated Reading Time: 4 mins</span></p> */}
                            <div className="blogHeadingDetails">
                                <figure>
                                    <img width="42" src="/img/blog/r_logo.svg" alt="icon"/>
                                </figure>
                                <ul>
                                    <li>Editorial Team</li>
                                    <li>Mar 4, 2025</li>
                                    <li>4 min read</li>
                                </ul>
                            </div>
                            <button onClick={()=> setShowGetstared(true)} className="btn btnBlue">Get Started</button>
                        </div>
                    </div>
                </div>
        </div>
        <div className='maxBannerRight'>
            <figure>
                <img  src="/img/blog/fleetBanner.jpg" alt="blog" />
            </figure>
        </div>
    </div>
</section>
{/* END maxBannerMain */}
 

{/* START maxBannerMain */}
<section className="choosePhotoMain">
    <div className="container">
        <div className='row'>
            <div className='col-lg-3 col-md-3 col-sm-12'>
                <div className='choosePhotoLeft'>
                    <ul>
                        {menuItems.map((item, index) => (
                            <li 
                                key={item.id} 
                                className={index === activeIndex ? "active" : ""}
                                onClick={() => setActiveIndex(index)}
                            >
                                <a href={`#${item.id}`}>{item.text}</a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <div className='col-lg-9 col-md-9 col-sm-12'>
                <div className='choosePhotoRight fleetOperatorRight'>
                    <div className='choosePhotoTop'>
                        <p>For thousands of fleet operators and car-sharing hosts, the recent shutdown of Getaround and HyreCar 
                        is more than just industry news—it’s deeply personal. It represents lost income, broken trust, and an 
                        uncertain future for hardworking individuals who built their businesses on these platforms. As 
                        the dust settles, one pressing question remains: <strong>What’s next?</strong></p>
                        
                        <figure className="fleet_figure">
                            <img className="img-fluid fleet_image" src="/img/blog/fleet_image.png" alt="blog"/>
                            <span>Photo Credit: Getaround</span>
                        </figure>
                        {/* <JoinPriorityWaitlistBtn buttonclass="btn btnBlue" buttonText="Get Started" /> */}
                        <button onClick={()=> setShowGetstared(true)} className="btn btnBlue">Get Started</button>
                    </div>

                    <div className='gradientBlogData'>
                            <h3>TL;DR</h3>
                            <p>In the wake of Getaround and HyreCar shutting down operations, many rental hosts are left navigating uncertainty and risk. Rentid provides a powerful, AI-driven platform for fleet operators looking to regain control, build resilience, and grow independently of volatile marketplaces. From smart automation to embedded protection tools, Rentid empowers operators to thrive in any market environment.</p>

                        </div>

                    <div className='choosePhotoData' id='fleet_blog_1'> 
                        <h2>Navigating the Uncertainty</h2>
                        <p>The closure of these once-promising rental marketplaces has left many hosts scrambling. Unpaid earnings, 
                        unresolved insurance claims, and vehicles sitting idle are just some of the challenges they now face. 
                        Many put their trust in a system that ultimately let them down. <strong>And now, they’re forced to make a choice:</strong></p>
                        <ul>
                            <li><strong>Stay on another marketplace and hope for the best.</strong> While platforms like Turo still exist, the 
                            reality is that hosts now face more competition, stricter policies, and a lack of control over their pricing, 
                            earnings, and customer relationships.</li>
                            <li><strong>Take control of their business and rent directly to their own customer base.</strong> While this may 
                            seem daunting, it offers long-term stability, greater profitability, and most importantly—<strong>freedom</strong>.</li>
                        </ul>
                        <p><strong>So, which path will you take?</strong></p>
                        <img className="img-fluid fleet_image_1" src="/img/blog/fleet_image_1.png" alt="blog"/>
                    </div>

                    <div className='choosePhotoData' id='fleet_blog_2'>
                        <h2>The Risks of Relying on Marketplaces</h2>
                        <p>The collapse of Getaround and HyreCar serves as a harsh reminder that <strong>third-party platforms own 
                        the relationship with customers—not hosts</strong>. When a marketplace disappears, so do years of built-up 
                        clientele, earnings, and trust.</p>
                        <p>Fleet operators remaining on marketplace platforms now face:</p>
                        <ul>
                            <li><strong>Financial Instability:</strong> If Getaround and HyreCar collapsed, what’s 
                            stopping another marketplace from facing the same fate?</li>
                            <li><strong>Loss of Control:</strong> Sudden changes in policies, pricing structures, 
                            and fees could impact profitability at any time.</li>
                            <li><strong>Intensified Competition:</strong> With thousands of displaced hosts flooding 
                            to surviving platforms, standing out and securing bookings will be harder than ever.</li>
                        </ul>
                        <p>While marketplaces can provide visibility, the reality is that they dictate the rules.</p> 
                        <p><strong>Hosts deserve better.</strong></p>
                        <figure className="fleet_figure">
                            <img className="img-fluid fleet_image_2" src="/img/blog/fleet_image_2.png" alt="blog"/>
                            <span>Photo Credit: Getaround</span>
                        </figure>
                        
                    </div>
 
  
                    <div className='choosePhotoData' id='fleet_blog_3'>
                        <h2>The Power of Direct Rentals</h2>
                        <p>Now more than ever, fleet operators are recognizing the value of independence. <strong>Owning your 
                            business means owning your future</strong>. By shifting to a direct rental model, operators can:</p>
                        <ul>
                            <li><strong>Maximize Profits</strong> – No more hefty commission fees eating into your revenue.</li>
                            <li><strong>Gain Full Control</strong> – Set your own pricing, policies, and customer experience.</li>
                            <li><strong>Build Customer Loyalty</strong> – Instead of relying on an algorithm, create lasting 
                            relationships that keep renters coming back.</li>
                        </ul>

                        <p>Of course, direct rentals come with challenges—particularly <strong>risk management, renter verification, 
                            and insurance protection</strong>. But that’s exactly where <strong>Rentid</strong> comes in.</p>

                        <figure className="fleet_figure">
                            <img className="img-fluid fleet_image_3" src="/img/blog/fleet_image_3.webp" alt="blog"/>
                            <span>Photo Credit: Rentid</span>
                        </figure>
                    </div> 

  
                    <div className='choosePhotoData' id='fleet_blog_4'>
                        <h2>How Rentid Helps Hosts Take Back Control</h2>
                        <p>At Rentid, we believe <strong>your fleet, your business, and your success should be in your hands—not a 
                        corporation’s.</strong> Our all-in-one platform is designed to help fleet operators <strong>seamlessly transition 
                        from marketplace dependency to independent business ownership</strong>—while <strong>eliminating risk and 
                        maximizing profitability.</strong></p>
                        <figure className="fleet_figure">
                            <img className="img-fluid fleet_image_4" src="/img/blog/fleet_image_4.png" alt="blog"/>
                            <span>Photo Credit: Rentid</span>
                        </figure>
                        
                        {/* <JoinPriorityWaitlistBtn buttonclass="btn btnBlue" buttonText="Get Started" /> */}
                        <button onClick={()=> setShowGetstared(true)} className="btn btnBlue">Get Started</button>

                        <p>With <strong>Rentid’s suite of cutting-edge solutions,</strong> hosts can confidently operate their rental 
                        business on their own terms:</p>


                        <div className='fleetListingMain'>
                            {/* start 1 */}
                            <div className='fleetListing'>
                                <div className='fleetListingLeft'>
                                    <img  src="/img/blog/rentdirect_icon.svg" alt="rent direct"/>
                                    <h4><span>rent</span>direct</h4>
                                </div>
                                <div className='fleetListingRight'>
                                    <p>A modern booking and rental management system that automates workflows, replaces 
                                    outdated software, and provides <strong>full control</strong> over your business 
                                    operations.</p>
                                </div>
                            </div>
                            
                             {/* start 2 */}
                            <div className='fleetListing'>
                                <div className='fleetListingLeft'>
                                    <img   src="/img/blog/rentID_icon.svg" alt="rent ID"/>
                                    <h4><span>rent</span>ID</h4>
                                </div>
                                <div className='fleetListingRight'>
                                    <p>An advanced trust and safety tool featuring <strong>AI-powered renter verification,</strong> personal auto insurance validation, and access to a <strong>national "Do Not Rent" list.</strong></p>
                                </div>
                            </div>

                             {/* start 3 */}
                            <div className='fleetListing'>
                                <div className='fleetListingLeft'>
                                    <img  src="/img/blog/rentshield_icon.svg" alt="rent shield"/>
                                    <h4><span>rent</span>shield</h4>
                                </div>
                                <div className='fleetListingRight'>
                                    <p>A flexible on-rent insurance solution providing <strong>State Minimum Liability, 
                                    optional Comprehensive Protection, and 24/7 roadside assistance</strong> to keep your 
                                    vehicles covered at all times.</p>
                                </div>
                            </div>

                             {/* start 4 */}
                            <div className='fleetListing'>
                                <div className='fleetListingLeft'>
                                    {/* <img   src="/img/blog/rentAI_icon.svg" alt="blog"/> */}
                                    <img src="/img/animation/rent_ai_logo_home.svg" alt="rent AI" height='72px'/>
                                    <h4><span>rent</span>AI</h4>
                                </div>
                                <div className='fleetListingRight'>
                                    <p>AI-powered operational tools that streamline fleet onboarding, customer 
                                    interactions, and <strong>automated customer service support.</strong></p>
                                </div>
                            </div> 

                             {/* start 5 */}
                            <div className='fleetListing'>
                                <div className='fleetListingLeft'>
                                    <img   src="/img/blog/rentsuccess_icon.svg" alt="rent success"/>
                                    <h4><span>rent</span>success</h4>
                                </div>
                                <div className='fleetListingRight'>
                                <p>A dedicated support system including <strong>insurance claim assistance, 
                                resolution management, and guest behavior reporting.</strong></p>
                                    
                                </div>
                            </div>

                            {/* start 6 */}
                            <div className='fleetListing'>
                                <div className='fleetListingLeft'>
                                    <img   src="/img/blog/rentacademy_icon.svg" alt="rent academy"/>
                                    <h4><span>rent</span>academy</h4>
                                </div>
                                <div className='fleetListingRight'>
                                    <p>Educational resources, expert coaching, and training to help hosts <strong>optimize 
                                        marketing, stay compliant, and scale their business.</strong></p>
                                </div>
                            </div>
                             {/* end 6 */}
                        </div>


                        <p>With Rentid, you don’t just rent cars—you <strong>own your future.</strong></p>
                        <img className="img-fluid fleet_image_41" src="/img/blog/fleet_image_41.png" alt="blog"/>
                    </div>

  
                    <div className='choosePhotoData' id='fleet_blog_5'>
                        <h2>Your Next Chapter Starts Now</h2>
                        <p>The end of Getaround and HyreCar is not the end of your business—it’s the beginning of something better. 
                        <strong>This is your opportunity to take back control.</strong> To build a stronger, more profitable rental 
                        business—without the limitations of a third-party marketplace.</p>
                        <p><strong>If you or someone you know has been affected by the shutdown of Getaround or HyreCar don’t 
                        wait</strong>. Lost income, unpaid earnings, and an uncertain future don’t have to define your 
                        next move. <strong>You have options.</strong></p>

                        <div className='fleetContact'>
                            <p>Contact us today to explore a <strong>secure, independent path forward</strong>—one that puts control, 
                            profitability, and stability back in your hands.</p>
                            <p><strong>#GetRentid today. Visit</strong> <a href="/getaround">https://rentid.io/getaround</a> <strong>to learn more.</strong></p>
                            <p><strong>Your business. Your rules. Your future.</strong></p>
                            {/* <JoinPriorityWaitlistBtn buttonclass="btn btnBlue" buttonText="Get Started" /> */}
                            <button onClick={()=> setShowGetstared(true)} className="btn btnBlue">Get Started</button>
                        </div>
                    </div>
                </div>

                {/* <BlogFaq/> */}
            </div>
        </div>
    </div>
 
</section>
{/* END maxBannerMain */}


<Footer/>
        </>
    )
}

export default FleetOperators;